module.exports = __webpack_public_path__ + "static/media/browser_background.951fe2d1.png";